import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/feature/SectionHeading';
import { manufacturingSteps, whyChooseUs } from '@/mocks/aboutData';

export default function AboutProcess() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Why Best Research Pharma"
          title="Quality You Can Trust, At Every Step"
          description="Our certifications, standards and hands-on process are what keep our partners coming back."
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {whyChooseUs.map((item, index) => (
            <Reveal key={item.id} delay={index * 90}>
              <div className="h-full rounded-lg border border-background-200 bg-background-100/70 p-5">
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading mt-4 text-base font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.description}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16">
          <div className="text-center">
            <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950">
              From Herb to Hand — Our Process
            </h3>
            <span className="block h-[3px] w-16 rounded-full bg-accent-500 mx-auto mt-4"></span>
          </div>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {manufacturingSteps.map((item, index) => (
              <Reveal key={item.id} delay={index * 80}>
                <div className="relative h-full rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className="font-heading text-3xl font-semibold text-background-300">{item.step}</span>
                  <span className="absolute top-5 right-5 w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <h4 className="font-heading mt-3 text-sm font-semibold text-foreground-950">{item.title}</h4>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600">{item.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}